import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';

import actions from 'state/paymentData/actionCreators';
import initialState from 'state/paymentData/initial.state';

const fiscal_info = handleActions(
  {
    [actions.changeFiscalInfo]: (state, { payload: { field, value } }) => ({
      ...state,
      [field]: value,
    }),
    [actions.changeBillingContact]: (state, { payload: { field, value } }) => ({
      ...state,
      billing_contact: {
        ...state.billing_contact,
        [field]: value,
      },
    }),
  },
  initialState.fiscal_info
);

const payment_method = handleActions(
  {
    [actions.selectPaymentMethod]: (state, { payload: { value } }) => ({
      ...state,
      ...initialState.payment_method,
      payment_method: value,
    }),
    [actions.changePaymentTerm]: (state, { payload: { field, value } }) => ({
      ...state,

      payment_term: {
        ...state.payment_term,
        [field]: value,
      },
    }),
  },
  initialState.payment_method
);

const reducer = combineReducers({
  fiscal_info,
  payment_method,
});

export default reducer;
